var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangePasswordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12656",
    "data-name": "Grupo 12656",
    transform: "translate(-78 -153)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_58",
    "data-name": "Elipse 58",
    cx: 110,
    cy: 110,
    r: 110,
    transform: "translate(78 153)",
    fill: "#ddd",
    opacity: 0.143
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10145",
    "data-name": "Caminho 10145",
    d: "M709.958,2506.157a2.272,2.272,0,0,0,2.267,2.264H834.79a2.272,2.272,0,0,0,2.266-2.264l1.02-70.435a3.947,3.947,0,0,0-4.156-3.494l-119.785-3.1a5.712,5.712,0,0,0-5.861,5.842Z",
    transform: "translate(-584.765 -2205.323)",
    fill: "#72716f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10146",
    "data-name": "Caminho 10146",
    d: "M737.4,2534.565a2.151,2.151,0,0,0,2.144,2.144H857.039a2.151,2.151,0,0,0,2.144-2.144l.962-63.942a5.277,5.277,0,0,0-5.532-5.149l-114.8-3.08a4.014,4.014,0,0,0-4.118,4.107Z",
    transform: "translate(-609.969 -2235.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2790",
    "data-name": "Ret\\xE2ngulo 2790",
    width: 144.5,
    height: 6.189,
    rx: 3.094,
    transform: "translate(259.75 308.946) rotate(180)",
    fill: "#72716f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12654",
    "data-name": "Grupo 12654",
    transform: "translate(153.682 204.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10170",
    "data-name": "Caminho 10170",
    d: "M1760.975,1626.9a2.333,2.333,0,0,1,1.8-.62c7.083.637,20.3-2.775,28.934-11.612.6-.613,1.693-.267,2.38.247,9.6,7.179,25.526,8.665,31.053,8.969a2.332,2.332,0,0,1,2.189,2.089c5.026,48.546-26.582,66.137-33.137,69.242a2.339,2.339,0,0,1-2.233-.129c-32.672-20.351-31.274-46.817-31.726-66.427A2.336,2.336,0,0,1,1760.975,1626.9Z",
    transform: "translate(-1760.237 -1614.338)",
    fill: "#f2cb30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10171",
    "data-name": "Caminho 10171",
    d: "M1849.912,1759.518a.78.78,0,0,1-.419-.122c-12.526-8.007-20.689-17.58-24.958-29.265-3.812-10.436-4-21.063-4.164-30.439l-.022-1.25a.764.764,0,0,1,.22-.554.774.774,0,0,1,.556-.232h0c7.757,0,19.4-3.425,27.94-11.077a.773.773,0,0,1,.944-.068c9.383,6.226,22.767,8.039,29.91,8.565a.771.771,0,0,1,.713.7c1.66,18.942-2.28,34.959-11.71,47.607a56.2,56.2,0,0,1-18.659,16.045h0A.77.77,0,0,1,1849.912,1759.518Zm.207-.368.073.142-.073-.142a55.866,55.866,0,0,0,18.55-15.953c9.383-12.584,13.3-28.528,11.648-47.389a.454.454,0,0,0-.42-.416c-7.174-.529-20.619-2.351-30.063-8.617a.456.456,0,0,0-.556.04c-8.6,7.708-20.334,11.158-28.145,11.158h0a.46.46,0,0,0-.335.137.446.446,0,0,0-.129.325l.022,1.25c.164,9.351.35,19.949,4.144,30.335,4.243,11.617,12.365,21.138,24.83,29.105A.457.457,0,0,0,1850.119,1759.15Z",
    transform: "translate(-1816.836 -1682.171)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12655",
    "data-name": "Grupo 12655",
    transform: "translate(172.264 221.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10172",
    "data-name": "Caminho 10172",
    d: "M2156.8,1920.657h-1.478a1.329,1.329,0,0,1-1.329-1.328v-5.05a3.273,3.273,0,0,0-3.273-3.273h-9.155a3.273,3.273,0,0,0-3.273,3.273v5.05a1.328,1.328,0,0,1-1.329,1.328h-1.478a1.328,1.328,0,0,1-1.328-1.328v-5.05a7.407,7.407,0,0,1,7.407-7.407h9.155a7.407,7.407,0,0,1,7.407,7.407v5.05A1.328,1.328,0,0,1,2156.8,1920.657Z",
    transform: "translate(-2130.888 -1906.872)",
    fill: "#fff",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10173",
    "data-name": "Caminho 10173",
    d: "M2105.894,2163.115h-24.976a2.771,2.771,0,0,0-2.771,2.771v19.167a2.771,2.771,0,0,0,2.771,2.771h24.976a2.771,2.771,0,0,0,2.771-2.771v-19.167A2.771,2.771,0,0,0,2105.894,2163.115Zm-8.914,18.525a1.027,1.027,0,0,1-1,1.267h-5.15a1.027,1.027,0,0,1-1-1.267l1.2-5a4.63,4.63,0,1,1,4.743,0Z",
    transform: "translate(-2078.148 -2148.138)",
    fill: "#fff",
    opacity: 0.61
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswordIcon);
export default __webpack_public_path__ + "static/media/change_password_icon.76e11edbf2f19d8499fc3e6815fb5181.svg";
export { ForwardRef as ReactComponent };